"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useState } from "react";

export default function QueryProvider({
	children,
}: {
	children: React.ReactNode;
}) {
	const [queryClient] = useState(
		() =>
			new QueryClient({
				defaultOptions: {
					queries: {
						// Cache for 5 minutes (300000ms) - important for real estate data
						staleTime: 5 * 60 * 1000,
						// Keep unused data in cache for 10 minutes
						gcTime: 10 * 60 * 1000,
						// Retry failed requests
						retry: 2,
						// Refetch on window focus (optional, can be disabled)
						refetchOnWindowFocus: false,
						// Refetch on reconnect
						refetchOnReconnect: true,
					},
				},
			})
	);

	return (
		<QueryClientProvider client={queryClient}>
			{children}
			{process.env.NODE_ENV === "development" && <ReactQueryDevtools />}
		</QueryClientProvider>
	);
}
